import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	fileUploadButtonText: {
		id: 'custom-sites-extensions.unsplash.upload.text',
		defaultMessage: 'Upload',
		description:
			'Text for button that opens dialog to be able to select an image from a users computer',
	},
	deleteImageButtonText: {
		id: 'custom-sites-extensions.unsplash.delete.image.text',
		defaultMessage: 'Remove image',
		description: 'Text for button that removes the selected image from the media picker',
	},
	defaultBackgroundImageAltText: {
		id: 'custom-sites-extensions.unsplash.background-img.default.label',
		defaultMessage: 'Default background image for upload previewer',
		description:
			'Alternative text for the background image in the upload preview section of the media picker',
	},
});
